import { createImageUrlBuilder, type SanityImageSource } from "@sanity/image-url";

import { dataset, projectId } from "@/sanity/env";

const builder = createImageUrlBuilder({ projectId, dataset });

export function urlForImage(source: SanityImageSource) {
  return builder.image(source);
}

/**
 * Appends `v=<document _updatedAt>` so browsers and `next/image` treat the URL as new when a
 * document (or its asset) is updated in Sanity, including Media Library replacements that keep
 * the same asset id. Safe when `documentUpdatedAt` is missing.
 */
export function sanityImageUrlWithDocumentVersion(
  imageUrl: string,
  documentUpdatedAt?: string | null,
): string {
  if (documentUpdatedAt == null || documentUpdatedAt === "") {
    return imageUrl;
  }
  const sep = imageUrl.includes("?") ? "&" : "?";
  return `${imageUrl}${sep}v=${encodeURIComponent(documentUpdatedAt)}`;
}
